<template>
  <div>
    <el-table :data="auditList" height="calc(100vh - 360px)">
      <el-table-column prop="id" label="订单id" width="200" />
      <el-table-column label="创建时间" width="200">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="审核时间" width="200">
        <template slot-scope="scope">{{
          scope.row.processTime | moment
        }}</template>
      </el-table-column>
      <el-table-column prop="userId" label="用户Id" width="80" />
      <el-table-column prop="topUserId" label="合伙人UID" width="120" />
      <el-table-column prop="txAmount" label="数量" width="80" />
      <el-table-column prop="txCoin" label="币种" width="80" />
      <el-table-column prop="chain" label="币种链" width="80" />
      <el-table-column prop="txFromWallet" label="转出钱包地址" width="300" />
      <el-table-column prop="txToWallet" label="转入钱包地址" width="300" />
      <el-table-column prop="txHash" label="hash" width="300">
        <!-- <template slot-scope="scope">
          <a :href="scope.row.txHash" target="_blank">
            {{ scope.row.txHash }}
          </a>
        </template> -->
      </el-table-column>
      <el-table-column prop="txNetworkLink" label="地址" width="300">
        <template slot-scope="scope">
          <a :href="scope.row.txNetworkLink" target="_blank">
            {{ scope.row.txNetworkLink }}
          </a>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="gas" label="gas"></el-table-column>
      <el-table-column prop="nonce" label="nonce"></el-table-column> -->
      <!-- <el-table-column prop="result" label="result">
        <template slot-scope="scope">{{scope.row.result+''}}</template>
      </el-table-column> -->
      <el-table-column prop="txDepositDesc" label="状态" width="140" />
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="handleCurrentChange"
    ></pagination>
  </div>
</template>

<script>
import Pagination from 'components/pagination'
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex'

export default {
  name: 'KYCAudit',
  data() {
    return {
      auditId: null,
    }
  },
  computed: {
    ...mapState('withrawRecord', ['pagination', 'totalCount', 'auditList']),
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapMutations('withrawRecord', ['setpage']),
    handleCurrentChange(pagination) {
      console.log('page', pagination)
      this.setpage(pagination)
      this.$emit('refresh', { ...pagination, type: 2 })
    },
  },
}
</script>

<style lang="less" scoped></style>
